export default __webpack_public_path__ + "static/media/NameCheap.aceb2860.jpg";